/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { VisualDisplayTypes } from '../enums';
import { hideSpinner } from '../../../store/spinner/spinner.reducers';
import { showErrorOverlay } from '../../../store/videoplayer/overlays/erroroverlay/erroroverlay.reducers';
import { Locale } from '../../locale/Locale';
import { LocaleKeys } from '../../locale/LocaleKeys';
import { OverlayTypes } from '../../../store/overlay/OverlayTypes';
import { showErrorOSD } from '../../../store/videoplayerui/osd/osd.reducers';
import { Log } from '../../logging';
import { setIsStreamingRestricted } from '../../../store/videoplayer/streamingrestriction/streamingrestriction.reducers';
import { showGuideScreen } from '../../../store/screens/screens.reducers';

export class PlaybackErrorDisplay {
    TAG: string = 'PlaybackErrorDisplay';

    private static dispatch: Function | undefined;

    private static mPlaybackErrorDisplay: PlaybackErrorDisplay;

    static getInstance(dispatch?: Function): PlaybackErrorDisplay {
        if (!PlaybackErrorDisplay.mPlaybackErrorDisplay) {
            PlaybackErrorDisplay.mPlaybackErrorDisplay = new PlaybackErrorDisplay();
            PlaybackErrorDisplay.dispatch = dispatch;
        }
        return PlaybackErrorDisplay.mPlaybackErrorDisplay;
    }

    // eslint-disable-next-line class-methods-use-this
    private onOverlayAutoHide(): void {
        PlaybackErrorDisplay.dispatch!(showGuideScreen());
    }

    public showVisualDisplay = (error: any) => {
        switch (error.getVisualDisplayType()) {
            case VisualDisplayTypes.OVERLAY:
                PlaybackErrorDisplay.dispatch!(hideSpinner());
                PlaybackErrorDisplay.dispatch!(
                    showErrorOverlay({
                        errorPriority: error.getPriority(),
                        title: error.getTitle(),
                        options: [
                            {
                                text: Locale.getString(LocaleKeys.OVERLAY_OPTION_OK_TEXT),
                            },
                        ],
                        messageCode: error.getUiErrorCode(),
                        description: error.getDescription(),
                        hasDimmer: false,
                        hasSeperator: false,
                        overlayType: OverlayTypes.ERROR,
                        onAutoHide: this.onOverlayAutoHide,
                    }),
                );
                break;
            case VisualDisplayTypes.OSD:
                PlaybackErrorDisplay.dispatch!(
                    showErrorOSD(
                        error.getUiErrorCode(),
                        error.getDescription(),
                        error.getPriority(),
                    ),
                );
                break;
            case VisualDisplayTypes.SPINNER:
                break;
            default:
        }
    };

    public setIsStreamingRestricted = (isStreamingRestricted: boolean) => {
        Diagnostics.debug(this.TAG, 'setIsStreamingRestricted: ', isStreamingRestricted);
        Log.d(this.TAG, 'setIsStreamingRestricted: ', isStreamingRestricted);
        PlaybackErrorDisplay.dispatch!(setIsStreamingRestricted(isStreamingRestricted));
    };
}
